export default __webpack_public_path__ + "static/media/private_pur.afd6030d.png";